import {FormProps} from "../shared/types";
import {
    AutocompleteArrayInput, AutocompleteInput, BooleanInput,
    ReferenceArrayInput, ReferenceInput,
    SimpleForm,
    TextInput
} from "react-admin";
import {initInput} from "../shared/utils";
import React from "react";


export const UserForm = (props: FormProps) => {
    return (
        <SimpleForm {...props}>
            <TextInput {...initInput("username", props.fieldOptions,)} />
            {!props.canEdit && <TextInput {...initInput("password", props.fieldOptions)}/>}
            <ReferenceArrayInput
                reference="autocomplete/group"
                label="Gruppi"
                source="groups"
                defaultValue={[]}
                variant="outlined"
            >
                <AutocompleteArrayInput
                    optionText="label"
                    fullWidth
                />
            </ReferenceArrayInput>
            <BooleanInput {...initInput("is_active", props.fieldOptions)}/>
        </SimpleForm>
    )
}